import {useQuery} from "@tanstack/react-query";
import {readCompanyMember} from "../../../../api/manage/company/CompanyApi";
import {CompanyMemberMapType, CompanySearchParamType} from "../interface";
import {companyMemberMapInit} from "../state";

interface Props {
    param: CompanySearchParamType,
    enabled: boolean
}

export const useReadCompanyMember = ({param, enabled}: Props): { data: CompanyMemberMapType } => {
    const {data} = useQuery({
        queryKey: ["readCompanyMember", param],
        queryFn: async () => await readCompanyMember(param),
        select: (res) => res?.data.result ?? companyMemberMapInit,
        enabled: enabled
    });

    return {data};
};
